function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import { CoreVideoInternal } from '../../../core-video-internal';
import { ChromecastModel, checkIsTizenVersion, TizenVersion } from '@sky-uk-ott/client-lib-js-device';
var TIZEN_2_X_START_OFFSET = 0.01;
var END_OFFSET = 0.5;
var LOW_SPEC_END_OFFSET = 0.7;
export var MediaTailorAdBreaksPositionAdapter = /*#__PURE__*/ function() {
    "use strict";
    function MediaTailorAdBreaksPositionAdapter() {
        _class_call_check(this, MediaTailorAdBreaksPositionAdapter);
    }
    _create_class(MediaTailorAdBreaksPositionAdapter, null, [
        {
            key: "getAdBreakStartAdjustment",
            value: function getAdBreakStartAdjustment() {
                var deviceInfo = CoreVideoInternal.deviceInfo;
                return checkIsTizenVersion(deviceInfo, TizenVersion['Tizen-2.3']) || checkIsTizenVersion(deviceInfo, TizenVersion['Tizen-2.4']) ? TIZEN_2_X_START_OFFSET : 0;
            }
        },
        {
            key: "getAdBreakEndAdjustment",
            value: function getAdBreakEndAdjustment() {
                var deviceInfo = CoreVideoInternal.deviceInfo;
                if (deviceInfo.operatingSystemName === 'Chromecast OS') {
                    switch(deviceInfo.deviceModel){
                        case ChromecastModel.ULTRA:
                            return 0.4;
                        default:
                            break;
                    }
                }
                return CoreVideoInternal.capabilities.hasLowerEndSpecs() ? LOW_SPEC_END_OFFSET : END_OFFSET;
            }
        }
    ]);
    return MediaTailorAdBreaksPositionAdapter;
}();

//# sourceMappingURL=media-tailor-ad-breaks-position-adapter.js.map